/* tslint:disable */

/**
 * The cost unit:
 *   * EUR
 */
type CostUnit =
  'EUR';
namespace CostUnit {
  export const EUR: CostUnit = 'EUR';
  export function values(): CostUnit[] {
    return [
      EUR
    ];
  }
}

export { CostUnit }